import React, { memo, useEffect, useState } from "react";
import { Row } from 'react-bootstrap';

import CurrentQuestion from "components/FullTest/CurrentQuestion";

const Question = memo(function Question({ question, props_data }) {
  const [showQuestion, setShowQuestion] = useState(false);
  // console.log(question,props_data);
  useEffect(() => {
    setTimeout(() => {
      setShowQuestion(true);
    }, 100);
  }, []);
  // console.log(showQuestion, "showQuestion");
  // console.log(question, "question");
  return (
    <Row className="unselectable" style={{ overflow: 'visible' }}>
      {showQuestion && (
        <CurrentQuestion
          subcategoryId={question?.subcategory_id}
          props_data={props_data}
        />
      )}
    </Row>
  );
});

export default Question;
